import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import { StackPullRequestsTableRunCellProps } from "../types";

const StackPullRequestsTableRunOpenedAtCell = ({
  item: { run },
  ...cellProps
}: StackPullRequestsTableRunCellProps) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp timestamp={run.createdAt} />
    </TableSimpleCell>
  );
};

export default StackPullRequestsTableRunOpenedAtCell;
